import { call, put } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actNotif from '../../actions/notifications';

import * as apiOutlet from '../../api/outlets';
import { assertErrorHasMessage } from '../../utils/assert';

/**
 * @param outletId
 * @param query
 * @return {object|boolean} json from server if successful, false if failed
 */
export function* getOutletById(outletId, query) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    const response = yield call(apiOutlet.getOutletById, outletId, query);
    return response.data;
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
    return false;
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}
